import { useState } from 'react'

import { ThumbnailContainer, ThumbnailImage, ThumbnailSkeleton } from './CertificateThumbnail.styles'

export interface CertificateThumbnailProps {
  src?: string
  onClick: () => void
}

const CertificateThumbnail: React.FC<CertificateThumbnailProps> = ({ src, onClick }) => {
  const [imageLoading, setImageLoading] = useState(true)

  const onLoadStart = () => {
    setImageLoading(true)
  }

  const onResetLoading = () => {
    setImageLoading(false)
  }

  return (
    <ThumbnailContainer title='Open image' onClick={onClick}>
      <ThumbnailImage
        src={src}
        alt='Certificate image preview'
        data-loading={imageLoading}
        onLoadStart={onLoadStart}
        onLoad={onResetLoading}
        onError={onResetLoading}
      />
      {imageLoading && <ThumbnailSkeleton variant='rectangular' />}
    </ThumbnailContainer>
  )
}

export default CertificateThumbnail
